import React from "react";
import useDashboardItems from "./dashboardItems";

const DashboardItemsWrapper = ({ children }) => {
  const items = useDashboardItems();
  return children(items);
};

export default DashboardItemsWrapper;
